import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input, RadioButton, SelectAutocompleteMultiple } from 'components';
import { enumValues, FindLoad, FindSuccessItem, manageType, useModal } from 'utils';
import { payrollActions } from 'store/payroll';
import { httpRequestsOnSuccessActions } from 'store';
import { applyOvertimeData, checkboxStyle, ptoData } from './constants';
import { PayrollSetupStyles } from '../styles';

export const PayCodeType = ({ info: propInfo }) => {
    const classes = PayrollSetupStyles();
    const dispatch = useDispatch();
    const { close } = useModal();
    const ACTION_TYPE = propInfo ? 'EDIT_PAY_CODE_BY_ID_GLOBAL' : 'CREATE_PAY_CODE_GLOBAL';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const location = useLocation();
    const info = location?.state;

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: {
            name: '',
            code: '',
            type: '',
        }
    });

    const [applyOvertime, setApplyOvertime] = useState('No');
    const [AccruePTO, setAccruePTO] = useState('No');

    const typeOptions = enumValues.PAYMENT_TYPES.map((t) => ({ id: t, title: t }));

    useEffect(() => {
        if (propInfo) {
            reset({
                name: propInfo.name || '',
                code: propInfo.code || '',
                type: manageType(propInfo.type) || '',
            });
            setApplyOvertime(propInfo.overtime === true ? 'Yes' : 'No');
            setAccruePTO(propInfo.pto === true ? 'Yes' : 'No');
        }
    }, [propInfo, reset]);


    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            if (!info) {
                reset();
                setApplyOvertime('No');
                setAccruePTO('No');
            }
        }
    }, [success]);

    // useEffect(() => {
    //     if (success) {
    //         if (propInfo) {
    //             close();
    //             dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    //         } else {
    //             close();
    //             dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    //             reset();
    //             setApplyOvertime('No');
    //             setAccruePTO('No');
    //         }
    //         dispatch(payrollActions.getPayCodeGlobal({ ...info }));
    //     }
    // }, [success]);

    const handleSave = (e) => {
        e && e.preventDefault();
        handleSubmit((data) => {
            const currentType = data.type;

            const payload = {
                name: data.name,
                code: data.code,
                type: manageType(currentType),
                overtime: applyOvertime === 'Yes',
                pto: AccruePTO === 'Yes',
            };
            
            if (propInfo) {
                dispatch(payrollActions.editPayCodeByIdGlobal(payload, propInfo.id));
            } else {
                dispatch(payrollActions.createPayCodeGlobal(payload));
            }
        })(e);
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{propInfo ? 'Edit Paycode Type' : 'Add Paycode Type'}</p>
            <form onSubmit={handleSave}>
                <div className="modal-body-wrapper">
                    <Input
                        name="name"
                        label="Name*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Name is required.',
                            maxLength: { value: 50, message: 'Max length is 50 characters.' },
                        }}
                    />
                    <Input
                        name="code"
                        label="Code*"
                        variant="outlined"
                        control={control}
                        maxLength={20}
                        rules={{
                            required: 'Code is required.',
                            maxLength: { value: 20, message: 'Max length is 20 characters.' },
                        }}
                    />
                    <SelectAutocompleteMultiple
                        control={control}
                        name="type"
                        label="Select Type*"
                        placeholder="Type"
                        options={typeOptions}
                        rules={{ required: 'Type is required.' }}
                    />
                    <div className={classes.flexBox}>
                        <div className={classes.checkboxContainer}>
                            <p>Apply Overtime?</p>
                            <RadioButton
                                styles={checkboxStyle}
                                value={applyOvertime}
                                onChange={(e) => setApplyOvertime(e.target.value)}
                                radioData={applyOvertimeData}
                            />
                        </div>
                        <div className={classes.checkboxContainer}>
                            <p>Accrue PTO?</p>
                            <RadioButton
                                styles={checkboxStyle}
                                value={AccruePTO}
                                onChange={(e) => setAccruePTO(e.target.value)}
                                radioData={ptoData}
                            />
                        </div>
                    </div>
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={propInfo ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
